module.exports = __webpack_public_path__ + "static/media/kg.99318e86.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kg.svg
// module id = 858
// module chunks = 0